export type EventViewTrackingRequestBody = {
  eventId: string;
  path: string;
  host: string;
};

export type EventViewTrackingRequest = Pick<EventViewTrackingRequestBody, 'eventId'>;

/**
 * Sends event view tracking data using Navigator.sendBeacon or fetch fallback
 * Only runs in browser environment (client-side)
 *
 * @returns Promise<boolean> - true if the request was successfully queued, false otherwise
 */
export const sendEventViewTracking = async ({ eventId }: EventViewTrackingRequest): Promise<boolean> => {
  // Only run in browser environment
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const payload: EventViewTrackingRequestBody = {
      eventId,
      path: window.location.pathname + window.location.search,
      host: window.location.host,
    };

    // Use sendBeacon if available (preferred method)
    if (navigator.sendBeacon) {
      return navigator.sendBeacon('/e/api/eventview', JSON.stringify(payload));
    } else {
      // Fallback to fetch if sendBeacon is not available
      await fetch('/e/api/eventview', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        keepalive: true, // Similar behavior to sendBeacon
      });
      return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // Silently ignore errors for tracking
    return false;
  }
};
